import { useSuspenseQuery } from "@tanstack/react-query";

import { viewQuery } from "@/api/views";
import PlanInterestForm from "@/modules/plan/ui/plan-interest-form";

// 더 큰 요금제 출시 알림 — 받는 분·이메일은 셸의 내 멤버 정보로 채운다(이미 /app 이 읽어 둔 셸이라 새 요청이 없다).
const PlanInterestPage = () => {
  const { data } = useSuspenseQuery(viewQuery("shell"));
  return (
    <div className="mx-auto w-full max-w-2xl">
      <PlanInterestForm defaultEmail={data.member.email ?? ""} defaultName={data.member.name} />
    </div>
  );
};

export default PlanInterestPage;
